var chassis = "https://shopfront-cdn.tekoapis.com/static/d1303b3e3941860c.svg";

export { chassis as default };
